<script setup lang="ts">
import { useSiteOptions } from "@/composables/site-options";

const { name, address, phone, email, social_medias } = useSiteOptions();
</script>

<template>
  <UiSocialMedias :items="social_medias" />
</template>
